import type { NavIconVariant } from "./types"

/** Label and search-disc chrome. Icon fill lives in `paint.tsx`; active glow is CSS drop-shadow. */
export const navLabelAppearance: Record<NavIconVariant, string> = {
  inactive: "",
  active:
    "text-white [text-shadow:0_0_8px_var(--color-nav-active-glow),0_0_22px_var(--color-nav-active-glow),0_0_36px_var(--color-nav-active-glow)]"
}

export const navIconActiveGlowClassName =
  "[filter:drop-shadow(0_0_4px_var(--color-nav-active-glow))_drop-shadow(0_0_12px_var(--color-nav-active-glow))_drop-shadow(0_0_24px_var(--color-nav-active-glow))]"

export const searchDiscAppearance: Record<NavIconVariant, string> = {
  inactive:
    "bg-purple-800 text-white/50 ring-2 ring-inset ring-white/20 bg-radial-[at_50%_120%] from-white/40 from-0% via-purple-400/40 via-50% to-transparent to-100%",
  active:
    "bg-purple-500 text-white ring-1 ring-inset ring-white/30 shadow-[0_0_8px_var(--color-purple-500),0_0_28px_var(--color-purple-400)] bg-radial-[at_50%_120%] from-white/50 from-0% via-purple-300/40 via-45% to-transparent to-100%"
}

export const navActiveUnderlineClassName =
  "pointer-events-none absolute inset-x-0 bottom-0 h-0.5 bg-purple-500"
